// Language Toggle Component
import React from 'react';
import { useAdminTranslation } from '../utils/i18nContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const LanguageToggle = () => {
  const { language, changeLanguage, t } = useAdminTranslation();

  const languages = [
    { code: 'en', label: 'English', flag: '🇺🇸' },
    { code: 'zh', label: '中文', flag: '🇨🇳' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' }
  ];

  return (
    <Select value={language} onValueChange={changeLanguage}>
      <SelectTrigger className="w-[160px] bg-[#0A0A0A] border-white/10 text-white">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#0A0A0A] border-white/10">
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code} className="text-white">
            {lang.flag} {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageToggle;
